import { useState, useEffect } from "react";
import WizardShell from "@/components/WizardShell";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import api from "@/lib/api";
import { toast } from "sonner";

export default function NotifySettingsWizard({ open, onOpenChange, tenant, onSaved }) {
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && tenant) setForm({
      notify_email1: tenant.notify_email1 !== false,
      notify_email2: tenant.notify_email2 !== false,
      notify_partner: !!tenant.notify_partner,
      auto_dunning: !!tenant.auto_dunning,
      send_overview_on_payment: !!tenant.send_overview_on_payment,
      notify_payout_email: tenant.notify_payout_email !== false,
      notify_payout_sms: !!tenant.notify_payout_sms,
    });
  }, [open, tenant]);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const finish = async () => {
    setLoading(true);
    try {
      await api.put(`/tenants/${tenant.id}`, { ...tenant, ...form });
      toast.success("Meldingsinstellingen opgeslagen");
      onSaved?.();
      onOpenChange(false); setStep(0);
    } catch (e) { toast.error("Opslaan mislukt"); }
    finally { setLoading(false); }
  };

  const Row = ({ k, title, desc, disabled }) => (
    <div className={`flex items-center justify-between border rounded-lg p-3 ${disabled ? "opacity-50" : ""}`}>
      <div><div className="text-sm font-medium text-slate-800">{title}</div><div className="text-xs text-slate-500">{desc}</div></div>
      <Switch checked={!!form[k]} disabled={disabled} onCheckedChange={(v) => set(k, v)} data-testid={`notify-${k}`} />
    </div>
  );

  return (
    <WizardShell open={open} onOpenChange={onOpenChange}
      title="Meldingsinstellingen debiteur"
      subtitle="Bepaal welke e-mails deze debiteur ontvangt"
      steps={["Ontvangers", "Automatisering"]}
      step={step} setStep={setStep} onFinish={finish} loading={loading} finishLabel="Instellingen opslaan">
      {step === 0 && (
        <div className="space-y-3">
          <Label>Naar welke adressen sturen we?</Label>
          <Row k="notify_email1" title="E-mail 1" desc={tenant?.email1 || "niet ingesteld"} disabled={!tenant?.email1} />
          <Row k="notify_email2" title="E-mail 2" desc={tenant?.email2 || "niet ingesteld"} disabled={!tenant?.email2} />
          <Row k="notify_partner" title="Partner-e-mail" desc={tenant?.partner_email || "niet ingesteld"} disabled={!tenant?.partner_email} />
        </div>
      )}
      {step === 1 && (
        <div className="space-y-3">
          <Row k="auto_dunning" title="Automatische aanmaning" desc="Verstuur herinneringen automatisch per e-mail zodra een termijn te laat is (anders alleen concept)" />
          <Row k="send_overview_on_payment" title="Overzicht na betaling" desc="Stuur automatisch een bijgewerkt betalingsoverzicht zodra een betaling is geregistreerd" />
          <Row k="notify_payout_email" title="Bevestiging uitbetaling (e-mail)" desc="Stuur een e-mailbevestiging naar de debiteur zodra een uitbetaling is uitgevoerd" />
          <Row k="notify_payout_sms" title="Bevestiging uitbetaling (SMS)" desc="Stuur een SMS-bevestiging bij een uitgevoerde uitbetaling (SMS is nog gemockt)" disabled={!tenant?.mobile1 && !tenant?.mobile2} />
        </div>
      )}
    </WizardShell>
  );
}
